// src/pages/departments/Departments.jsx
import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import DepartmentsTable from "../../components/Departments/DepartmentsTable";

const Departments = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <DepartmentsTable />
        </WrapperSection>
    );
};

export default Departments;
